import { applySavedColumnOrder } from "./tableColumnPreferences";

export function extractColumnsConfig(response) {
  if (Array.isArray(response)) return response;
  if (response?.columns && Array.isArray(response.columns)) return response.columns;
  if (response?.columns_config && Array.isArray(response.columns_config)) return response.columns_config;
  return null;
}

/** API column schema with optional user column order from localStorage. */
export function resolveBookColumns(apiColumns, tableId) {
  if (!Array.isArray(apiColumns) || apiColumns.length === 0) return [];
  return applySavedColumnOrder(apiColumns, tableId);
}
